import { Reducer } from 'redux'
import { SubscriptionState, SubscriptionTypes } from './types'

const INITIAL_STATE: SubscriptionState = {
  error: null,
  status: 'idle',
  subscriptions: [],
}

const reducer: Reducer<SubscriptionState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SubscriptionTypes.FETCH_SUBSCRIPTIONS_REQUEST:
      return { ...state, status: 'loading' }

    case SubscriptionTypes.FETCH_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        status: 'error',
        error: action.payload.error,
      }

    case SubscriptionTypes.FETCH_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        status: 'success',
        subscriptions: action.payload.subscriptions,
      }

    case SubscriptionTypes.CLEAR_SUBSCRIPTIONS:
      return { ...INITIAL_STATE }

    default:
      return state
  }
}

export default reducer
